import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';
import classNames from 'classnames';
import { universalStyles, purple } from '../../../../app/theme';
import { BASE_URL, IMAGE_PATHS } from '../../../../constants/paths.constants';

const useStyles = makeStyles(() => ({
  ...universalStyles,
  headerImage: {
    display: 'block',
    width: '100%',
  },
  heading: {
    marginTop: 50,
    marginBottom: 20,
  },
  flex: {
    display: 'flex',
    marginTop: 50,
  },
  col: {
    flex: 1,
    padding: '50px 2.5% 50px 2.5%',
    marginLeft: -1,
    border: `1px solid ${purple}`,
  },
  checkmark: {
    width: '40%',
    marginLeft: '30%',
    paddingBottom: 20,
  },
}));

const AcquisitionPage05 = (): JSX.Element => {
  const classes = useStyles();

  return (
    <>
      <div className={classes.grayBox}>
        <img
          className={classes.headerImage}
          src={`${BASE_URL}${IMAGE_PATHS.STEPS[1].ACQUISITION_STEP_1.path}`}
          alt={`${IMAGE_PATHS.STEPS[1].ACQUISITION_STEP_1.alt}`}
        />
        <div className={classes.whiteBox}>
          <Typography variant="h2">STEP 1:</Typography>
          <Typography variant="h3">Instrumentation for Use with Axumin</Typography>
          <div className={classes.flex}>
            <div className={classes.col}>
              <img
                className={classNames(classes.checkmark)}
                src={`${BASE_URL}${IMAGE_PATHS.YES_CHECK.path}`}
                alt={`${IMAGE_PATHS.YES_CHECK.alt}`}
              />
              <Typography variant="body1">
                <b>PET/CT</b>
                <br />
                To achieve optimal diagnostic performance follow the Axumin image acquisition guidance
              </Typography>
            </div>
            <div className={classes.col}>
              <img
                className={classNames(classes.checkmark)}
                src={`${BASE_URL}${IMAGE_PATHS.YES_CHECK.path}`}
                alt={`${IMAGE_PATHS.YES_CHECK.alt}`}
              />
              <Typography variant="body1">
                <b>PET/MRI</b>
                <br />
                Some institutions are gaining clinical experience of imaging Axumin on a PET/MRI scanner
              </Typography>
            </div>
            <div className={classes.col}>
              <img
                className={classNames(classes.checkmark)}
                src={`${BASE_URL}${IMAGE_PATHS.NO_X.path}`}
                alt={`${IMAGE_PATHS.NO_X.alt}`}
              />
              <Typography variant="body1">
                <b>Not recommended for use with Axumin:</b>
                <br />
                Dual-head coincidence cameras or PET stand-alone cameras
              </Typography>
            </div>
          </div>
          <Typography variant="h5" className={classes.heading}>
            Additional Information on PET/CT scans
          </Typography>
          <ul className={classNames(classes.list)}>
            <li>
              CT should be acquired per site standards; however, a small lesion observed with PET imaging may be better
              characterized with a high-quality CT scan
            </li>
            <ul className={classNames(classes.list, classes.nestedList)}>
              <li>
                A high-quality CT image acquisition for anatomic correlation and attenuation correction is recommended
              </li>
              <li>Regardless of the CT technique used, a careful review of the CT image is necessary</li>
            </ul>
            <li>
              Administration of intravenous (iodinated) or oral CT contrast media is not required when acquiring an
              Axumin PET/CT scan
            </li>
            <ul className={classNames(classes.list, classes.nestedList)}>
              <li>
                If use of intravenous (iodinated) CT contrast is standard of practice at a site, it is recommended that
                contrast is administered after completion of Axumin PET/CT scan
              </li>
            </ul>
          </ul>
        </div>
      </div>
    </>
  );
};

export default AcquisitionPage05;
